import * as React from "react";
import styled, { css } from "styled-components";
import { JSONClipboardIconButton } from "components/common";
import { ButtonToolbar } from "components/bootstrap";
import IconButton from "components/common/IconButton";
const StyledButtonToolbar = styled(ButtonToolbar)(
  ({ theme }) => css`
    position: absolute;
    right: 1px;
    top: 0;
    max-height: 100%;
    background-color: ${theme.colors.table.row.backgroundHover};
  `
);
const LogViewRowActions = ({ message, onShowDetails }) => /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, /* @__PURE__ */ React.createElement(JSONClipboardIconButton, { buttonTitle: "Copy message", content: message }), /* @__PURE__ */ React.createElement(IconButton, { title: "Open message details", name: "open_in_full", onClick: onShowDetails }));
export default LogViewRowActions;
